import type { PdsApiOrder } from '../api/types';

const HOUR = 3_600_000;
export const FAKE_HISTORY_SIZE = 87;

const CUSTOMERS: Pick<PdsApiOrder, 'customerName' | 'phone'>[] = [
  { customerName: 'Mme Dubois' },
  { customerName: 'Restaurant Den Anker' },
  { phone: '+32 472 18 90 33' },
  { customerName: 'Traiteur Grimbergen' },
  { customerName: 'Mme Janssens' },
  { customerName: 'Table 4' },
  { customerName: 'Mme Willems' },
  { customerName: 'M. Peeters' },
  { customerName: 'Mme Caron' },
  { phone: '+32 493 55 18 02' },
  { customerName: 'Boulangerie Lemaire' },
  { customerName: 'M. Claes' },
];

// Les quatre plus récentes sont en cours, ensuite la plupart sont remises.
const statusOf = (index: number) => {
  if (index < 4)
    return ['pending', 'in_progress', 'in_progress', 'ready'][index];
  return [
    'served',
    'served',
    'served',
    'served',
    'served',
    'served',
    'cancelled',
    'rejected',
    'completed',
  ][index % 9];
};

export const buildFakeHistory = (now: number): PdsApiOrder[] =>
  Array.from({ length: FAKE_HISTORY_SIZE }, (_, index): PdsApiOrder => {
    const status = statusOf(index);
    const orderedAt = now - index * 11 * HOUR;
    const refunded = status === 'cancelled' || status === 'rejected';
    const sequence = FAKE_HISTORY_SIZE - index;

    return {
      id: `h-${sequence}`,
      orderNumber: `R01-2610-${String(sequence).padStart(6, '0')}`,
      status,
      paymentStatus: refunded ? 'refunded' : 'paid',
      paymentMethod: index % 5 === 4 ? 'cash' : 'online',
      channel: index % 4 === 3 ? 'pos_register' : 'click_and_collect',
      orderDate: new Date(orderedAt).toISOString(),
      pickupTime: new Date(orderedAt + 2 * HOUR).toISOString(),
      totalPrice: 12 + ((index * 37) % 240) + (index % 5) * 0.4,
      rejectReason: status === 'rejected' ? 'Produit indisponible' : null,
      items: Array.from({ length: 1 + (index % 4) }, (__, line) => ({
        id: `h-${sequence}-${line}`,
        qty: 1 + ((index + line) % 3),
        product: { designation: 'Produit' },
      })),
      customerName: null,
      phone: null,
      ...CUSTOMERS[index % CUSTOMERS.length],
    };
  });
